import { jsx as s } from "react/jsx-runtime";
import { useState as m, useEffect as n } from "react";
function p({
  children: o,
  delay: t = 0,
  renderWhenHidden: u = !0
}) {
  const [r, e] = m(t === 0);
  return n(() => {
    if (t === 0) {
      e(!0);
      return;
    }
    const i = setTimeout(() => e(!0), t);
    return () => clearTimeout(i);
  }, [t]), !u && !r ? null : /* @__PURE__ */ s("div", { style: { opacity: Number(r) }, children: o });
}
export {
  p as ShowAfter
};
//# sourceMappingURL=ShowAfter.js.map
